/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCommentRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {GetCommentResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const getComment = (request:GetCommentRequest, options?: CashRequestOptions) => post<GetCommentRequest, GetCommentResponse>("/2.0/cash/get-comment", request, {...options, rejectOnError: true })